
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.352 1.588h4.764a.794.794 0 000-1.588H6.353a.794.794 0 100 1.588zm4.628 6.636l-2.807 2.807a.794.794 0 101.123 1.123l2.807-2.807a.794.794 0 10-1.123-1.123z","fill":"#fff"}}),_c('path',{attrs:{"d":"M8.734 2.859A8.73 8.73 0 000 11.593a8.73 8.73 0 008.734 8.734 8.73 8.73 0 008.735-8.734 8.73 8.73 0 00-8.735-8.734zm0 15.88c-3.94 0-7.146-3.206-7.146-7.146s3.206-7.146 7.146-7.146 7.147 3.205 7.147 7.146c0 3.94-3.206 7.146-7.147 7.146z","fill":"#fff"}})])
          )
        }
      }
    